<script>
import CommonTableComponent from "@/components/table.vue";
import number from "@/mixins/number";
import tableSearch from "@/mixins/tableSearch";
import DatePicker from "vue2-datepicker";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";
import estimate from "@/mixins/estimate"

export default {
  name: "WasteInput",
  components: {
    CommonTableComponent,
    DatePicker,
  },
  mixins: [number, tableSearch, dailyReportControlRules, estimate],
  props: {
    wasteOrServiceByDailyReport: {
      type: Object,
      required: true,
    },
    dailyReport: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {},
    },
    indexWasteOrService: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    controlRules: {
      type: Object|null,
    },
    canBeDelete: {
      type: Boolean,
      default: false,
    },
    cars: {
      type: Array|null,
      required: true,
    },
    isApproveSidePage: {
      type: Boolean,
      default: false,
    },
    isMaintenanceSidePage:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    scheduleIdWithSubId(wasteOrService) {
      return [
        this.dailyReport.schedule_id,
        wasteOrService?.daily_report_sub_id,
      ].filter(x => !!x).join('-')
    },
    wasteName(wasteOrService) {
      let wasteOrServiceInJson = this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id);
      return wasteOrServiceInJson?.waste?.name;
    },
    wasteCategoryName(wasteOrService) {
      let wasteOrServiceInJson = this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id);
      return wasteOrServiceInJson?.waste?.waste_category?.name_abbreviated;
    },
    removeWasteAfterTreatment(wasteOrService, index_waste_after_treatment) {
      if (!this.canSelectAfterTreatment) return;

      wasteOrService.wastes_after_treatment_by_daily_report.splice(index_waste_after_treatment, 1);
    },
    getProductName(estimate) {
      return estimate.invoice_product_name;
    },
    getZzUnit(estimate) {
      return estimate.zz_unit?.unit;
    },
    getZzUnitBGColorClass(estimate) {
      return (estimate.zz_unit.id != '06');
    },
    openModalSelectWaste() {
      this.$emit('openModalSelectWaste', this.wasteOrServiceByDailyReport);
    },
    deleteWaste() {
      this.$emit('deleteWaste', this.wasteOrServiceByDailyReport);
    },
    isApproved(isTrans = false) {
      // メンテナンスページであればすべて許可する
      if(this.isMaintenanceSidePage) return false;
      if (this.dailyReport.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.transportation_disposal) {
        if (this.vendorSiteId) {
          return parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
        }

        return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
      }else if(this.dailyReport.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.disposal){
        // 処分の時、搬入完了時は運搬系のフォームはreadonlyとする
        if(isTrans && parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 3){
          return true;
        }
      }
      return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
      || parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
    },
    vendorSiteId() {
      return this.$route.query.vendor_site_id ?? null;
    },
    isDisplaied(item){
      if(item.type == "all") return true;
      if(item.type == "approve" && this.isApproveSidePage) return true;
      return false;
    },
    getUnitPrice(estimate){
      let end = this.$moment(this.dailyReport.schedule.end_datetime).format('YYYY-MM-DD');
      return this.getRecentUnitPrice(estimate, end);
    },
    getIsApproveSidePage(){
      return this.isApproveSidePage;
    },
    getTargetWasteOrServiceFromJson(targetId){
      return this.dailyReport.work_order_json.waste_or_service_by_work_order.find((item) => item.id == targetId);
    },
    messageForAfterTreatment(isGetColorClass = false){
      var isOwn = this.$constant.zzOwnId.is_own;
      let ownCount = this.wasteOrServiceByDailyReport.disposal_site_list_of_after.filter(function(item){
        return item.disposal_site_by_waste_category.vendor_site_after_treatment.zz_own_id == isOwn;
      }).length;
      // 処理後廃棄物処分場が全て他社：メッセージ無し
      // 処理後廃棄物処分場に自社があり、かつ自社が複数：メッセージと処分場表示
      // 処理後廃棄物処分場が1個所でありそれが自社：特殊メッセージ表示
      // 処理後廃棄物処分場に自社があり、自社が一つ：メッセージのみ表示
      if(ownCount === 0){
        return "";
      }else if(ownCount > 1){
        return isGetColorClass?"green":"※処分後情報に有価物があります（処分場："+this.wasteOrServiceByDailyReport.vendor_site.name_abbreviated+"）";
      } else if (this.wasteOrServiceByDailyReport.disposal_site_list_of_after.length == 1 && ownCount == 1){
        // ちょうど1の場合のメッセージを追加
        return isGetColorClass?"red":"※処分後情報は有価物のみに設定されています";
      }else if(ownCount > 0){
        return isGetColorClass?"green":"※処分後情報に有価物があります";
      }else{
        "";
      }
    }
  },
  computed: {
    estimateHeaders() {
      return [
        {
          text: "見積明細番号",
          value: "estimate_cd",
          sortable: false,
          type: "all",
          additionalClasses: 'estimate_cd'
        },
        {
          text: "請求書表示用商品名",
          value: "product_name",
          sortable: false,
          type: "all",
          additionalClasses: "product_name"
        },
        {
          text: "数量",
          value: "quantity",
          sortable: false,
          type: "all",
          additionalClasses: "quantity"
        },
        {
          text: "単位",
          value: "unit",
          sortable: false,
          type: "all",
          additionalClasses: "unit"
        },
        {
          text: "単価",
          value: "unit_price",
          sortable: false,
          type: "approve",
          additionalClasses: "unit_price"
        },
        {
          text: "空容器数量",
          value: "number_of_rental_containers",
          sortable: false,
          type: "all",
          additionalClasses: "number_of_rental_containers",
        },
      ];
    },
    zzManifestTypes() {
      return this.$store.getters['options/options_tables'].zz_manifest_types ?? [];
    },
    zzJwUnits() {
      const units = this.$store.getters['options/options_tables'].zz_jw_units ?? [];

      if (this.dailyReport.work_order_json.zz_work_order_type_id !== this.$constant.work_order_type.discharge) {
        return units.filter(x => x.id !== this.$constant.zzJUnits.piece);
      }

      return units;
    },
    zzValuablesInvolvedTypes() {
      return this.$store.getters['options/options_tables'].zz_valuables_involved_types ?? [];
    },
    canSelectAfterTreatment() {
      return this.wasteOrServiceByDailyReport.zz_valuables_involved_type_id !== this.$constant.zzValuablesInvolvedType.total;
    },
    usersOption() {
      return this.dailyReport.schedule.assigned_staffs_by_schedule ?? [];
    },
    carOptions() {
      if (!this.dailyReport || !this.dailyReport.schedule|| !this.isDisplayControl('car_selected')) {
        return [];
      }

      if (this.cars) {
        return this.cars.map(car => {
          car.display_name = [car.area_name, car.classification_number, car.hiragana, car.number].filter(x => !!x).join('－');
          return car;
        });
      }

      return this.dailyReport.schedule.assigned_cars_by_schedule.map(assigned_car => {
        assigned_car.display_name = [assigned_car.area_name, assigned_car.classification_number, assigned_car.hiragana, assigned_car.number].filter(x => !!x).join('－');

        return assigned_car;
      });

    },
  },
  watch: {
    'wasteOrServiceByDailyReport.zz_valuables_involved_type_id': {
      handler: function (val) {
        if (val === this.$constant.zzValuablesInvolvedType.total) {
          this.wasteOrServiceByDailyReport.wastes_after_treatment_by_daily_report = [];
        }
      },
      deep: true,
    },
    // 初期表示やcarOptionsが変更された際に先頭を選択するための処理なんだろうけどいらなくない？
    // 初期表示の場合は空欄。
    carOptions: {
      handler: function (val) {
        //if (val.length && !this.wasteOrServiceByDailyReport.car_selected) {
        //  this.wasteOrServiceByDailyReport.car_selected = val[0].id;
        //}
      },
      immediate: true,
    },
  },
}
</script>

<template>
  <b-card>
    <b-row v-if="isDisplayControl('schedule_id')">
      <div class="d-flex justify-content-between">
        <div>
          <label class="me-3">受付番号-枝番</label>
          {{scheduleIdWithSubId(wasteOrServiceByDailyReport)}}
          <span v-if="isApproved(true)">(承認済)</span>
        </div>
        <div
          v-if="canBeDelete"
        >
          <b-btn
            class="btn-custom-red"
            :disabled="isApproved(true)"
            @click="deleteWaste"
          >
            <i class="fas fa-eraser"></i> 削除
          </b-btn>
        </div>
      </div>
    </b-row>
    <b-row class="mt-2" v-if="isDisplayControl('waste_service_name') || isDisplayControl('waste_service_category_name')">
      <b-col cols="5" v-if="isDisplayControl('waste_service_name')">
        <div>
          <label class="me-3">廃棄物名称</label>
          {{wasteName(wasteOrServiceByDailyReport)}}
        </div>
      </b-col>
      <b-col cols="5" v-if="isDisplayControl('waste_service_category_name')">
        <div class="fs-5 fw-bold" style="font-weight:bold; color:red;">
          <label class="me-3">廃棄物種類</label>
          {{wasteCategoryName(wasteOrServiceByDailyReport)}}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="isDisplayControl('date_of_issue') || isDisplayControl('zz_manifest_type_id')">
      <b-col v-if="isDisplayControl('date_of_issue')">
        <div class="d-flex">
          <label class="text-nowrap label-static-width">交付年月日（引渡完了日）</label>
          <date-picker
            :disabled="isReadonly('date_of_issue') || isApproved(true)"
            v-model="wasteOrServiceByDailyReport.date_of_issue"
            lang="ja"
            placeholder="YYYY-MM-DD"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            class="date_of_issue"
          ></date-picker>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.date_of_issue`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.date_of_issue`][0] }}
        </div>
      </b-col>
      <b-col style="margin-top: 7px;" v-if="isDisplayControl('zz_manifest_type_id')">
        <div class="custom-radio-group gap-2">
          <label class="label-group label-static-width">媒体</label>
          <b-form-radio-group
            :disabled="isReadonly('zz_manifest_type_id') || isApproved(true)"
            class="d-flex align-items-center gap-2 w-100 h-100 custom-checkbox custom-control-input"
            :options="zzManifestTypes"
            text-field="manifest_type"
            value-field="id"
            v-model="wasteOrServiceByDailyReport.zz_manifest_type_id"
          ></b-form-radio-group>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_manifest_type_id`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_manifest_type_id`][0] }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="isDisplayControl('manifest_number') || isDisplayControl('remarks')">
      <b-col v-if="isDisplayControl('manifest_number')">
        <div class="d-flex">
          <label class="text-nowrap label-static-width">マニフェスト番号</label>
          <b-form-input
            :disabled="isReadonly('manifest_number') || isApproved(true) "
            v-model="wasteOrServiceByDailyReport.manifest_number"
            type="text"
            maxlength="11"
            class="manifest_number"
          ></b-form-input>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.manifest_number`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.manifest_number`][0] }}
        </div>
      </b-col>
      <b-col v-if="isDisplayControl('remarks')">
        <div class="d-flex">
          <label class="label-static-width">備考（管理番号）</label>
          <b-form-input
            :disabled="isReadonly('remarks') || isApproved(true) "
            v-model="wasteOrServiceByDailyReport.remarks"
            type="text"
            class="remarks"
          ></b-form-input>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.remarks`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.remarks`][0] }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col v-if="isDisplayControl('car_selected')">
        <div class="d-flex">
          <label class="label-static-width">車両番号選択</label>
          <b-form-select
            :disabled="isApproved(true)"
            :id="'car_select_' + indexWasteOrService"
            :options="carOptions"
            v-model="wasteOrServiceByDailyReport.car_selected"
            value-field="id"
            text-field="display_name"
            class="form-select custom-select car_selected"
          ></b-form-select>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.car_selected`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.car_selected`][0] }}
        </div>
      </b-col>
      <b-col v-if="isDisplayControl('user_id')">
        <div class="d-flex">
          <label class="label-static-width">運搬担当者</label>
          <b-form-select
            :disabled="isReadonly('user_id') || isApproved(true)"
            id="department"
            :options="usersOption"
            v-model="wasteOrServiceByDailyReport.user_id"
            value-field="id"
            text-field="user_name"
            class="form-select custom-select user_id"
          ></b-form-select>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.user_id`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.user_id`][0] }}
        </div>
      </b-col>
      </b-row>
      <b-row class="mt-2">
      <b-col v-if="isDisplayControl('transport_completed_date')">
        <div class="d-flex">
          <label class="label-static-width">運搬終了日</label>
          <date-picker
            :disabled="isReadonly('transport_completed_date') || isApproved(true)"
            v-model="wasteOrServiceByDailyReport.transport_completed_date"
            lang="ja"
            placeholder="YYYY-MM-DD"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            position="left"
            class="transport_completed_date"
          ></date-picker>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.transport_completed_date`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.transport_completed_date`][0] }}
        </div>
      </b-col>
      <b-col v-if="isDisplayControl('measurement_quantity') || isDisplayControl('zz_quantity_confirmation_unit_id')">
        <div class="d-flex">
          <label class="label-static-width">確定数量</label>
          <b-form-input
            v-if="isDisplayControl('measurement_quantity')"
            :disabled="isReadonly('measurement_quantity') || isApproved(true) "
            @keyup="setMinNumber($event)"
            v-model="wasteOrServiceByDailyReport.measurement_quantity"
            type="number"
            min="0"
            max="99999.999"
            class="measurement_quantity"
          ></b-form-input>
          <b-form-radio-group
            v-if="isDisplayControl('zz_quantity_confirmation_unit_id')"
            :disabled="isReadonly('zz_quantity_confirmation_unit_id') || isApproved(true) "
            text-field="jw_unit"
            value-field="id"
            v-model="wasteOrServiceByDailyReport.zz_quantity_confirmation_unit_id"
            class="d-flex text-nowrap"
            :options="zzJwUnits"
          ></b-form-radio-group>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.measurement_quantity`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.measurement_quantity`][0] }}
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_quantity_confirmation_unit_id`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_quantity_confirmation_unit_id`][0] }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <div class="custom-table gap-2" v-if="isDisplayControl('estimates')">
        <div class="title">見積明細</div>
        <CommonTableComponent class="table-custom" :height-class="`table-wrapper-500`">
          <thead class="table-light">
          <tr>
            <template v-for="(item, index) in estimateHeaders">
            <th
               v-if="isDisplaied(item)"
              :class="getHeaderClass(item)"
            >
                  <span>
                  {{ item.text }}
                  </span>
            </th>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(estimate, estimateIndex) in wasteOrServiceByDailyReport.estimates_by_daily_report"
            :key="`estimate_${wasteOrServiceByDailyReport.id}_${estimate.id}`"
          >
            <td>{{ estimate.estimate_cd }}</td>
            <td>{{ getProductName(estimate) }}</td>
            <td>
              <b-form-input
                :disabled="isReadonly('estimates.quantity') || isApproved(true) "
                @keyup="setMinNumber($event)"
                type="number"
                v-model="estimate.quantity"
                min="0"
              ></b-form-input>
              <div
                v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`]"
                class="error-message"
              >
                {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`][0] }}
              </div>
              <div v-if="errors[`wastes_or_services_by_daily_report.0.estimates_by_daily_report.quantity`]" class="error-message">
                {{ errors[`wastes_or_services_by_daily_report.0.estimates_by_daily_report.quantity`][0] }}
              </div>
            </td>
            <td :class="{bg_notice:getZzUnitBGColorClass(estimate)}">
              {{getZzUnit(estimate)}}
            </td>
            <td v-if="getIsApproveSidePage()">
              {{getUnitPrice(estimate)}}
            </td>
            <td>
              <b-form-input
                class="input-field"
                :disabled="true"
                :value="estimate.number_of_rental_containers"
                type="text"
                maxLength="50"
              ></b-form-input>
            </td>
          </tr>
          <tr v-if="!wasteOrServiceByDailyReport.estimates_by_daily_report.length && !isLoading">
            <td colspan="6" class="text-center">
              データなし。
            </td>
          </tr>
          </tbody>
        </CommonTableComponent>
      </div>
      <div
        v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`]"
        class="error-message"
      >
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`][0] }}
      </div>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="3" v-if="isDisplayControl('treatment_completed_date')">
        <div class="custom-datepicker gap-2">
          <label for="planned_start_date">処分終了年月日</label>
          <date-picker
            :disabled="isReadonly('treatment_completed_date') || isApproved(false)"
            v-model="wasteOrServiceByDailyReport.treatment_completed_date"
            lang="ja"
            placeholder="YYYY-MM-DD"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            position="left"
            class="treatment_completed_date"
          ></date-picker>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.treatment_completed_date`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.treatment_completed_date`][0] }}
        </div>
      </b-col>
      </b-row>
      <b-row class="mt-4">
      <b-col v-if="isDisplayControl('zz_valuables_involved_type_id')">
        <div class="custom-radio-group gap-2">
          <label class="label-group">有価物選択</label>
          <b-form-radio-group
            :disabled="isReadonly('zz_valuables_involved_type_id') || isApproved(false)"
            v-model="wasteOrServiceByDailyReport.zz_valuables_involved_type_id"
            class="d-flex align-items-center gap-2 w-100 h-100 custom-checkbox custom-control-input"
            text-field="valuables_involved_type"
            value-field="id"
            :options="zzValuablesInvolvedTypes"
          ></b-form-radio-group>
        </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_valuables_involved_type_id`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_valuables_involved_type_id`][0] }}
        </div>
      </b-col>
      <b-col v-if="isDisplayControl('zz_valuables_involved_type_id')">
        <div class="gap-2 valuable-involved-type-note"
        :class="messageForAfterTreatment(true)">
          {{ messageForAfterTreatment(false) }}
        </div>
      </b-col>
    </b-row>
    <template v-if="isDisplayControl('wastes_after_treatment_by_daily_report')">
      <b-row class="mt-2">
        <div class="d-flex gap-3">
          <b-button
            :disabled="isReadonly('wastes_after_treatment_by_daily_report') || isApproved(false) || !canSelectAfterTreatment"
            @click="openModalSelectWaste(wasteOrServiceByDailyReport)"
            variant="primary"
          >
          <i class="fas fa-list-alt"></i>
          処理後廃棄物を選択する</b-button>
        </div>
      </b-row>
      <b-row class="mt-2">
      <div class="selected-vehicles d-flex gap-2 flex-wrap">
        <b-badge
          v-for="(waste_after_treatment, index_waste_after_treatment) in wasteOrServiceByDailyReport.wastes_after_treatment_by_daily_report"
          :key="`waste_after_treatment_${indexWasteOrService}_${index_waste_after_treatment}`"
          variant="primary"
        >
          {{ waste_after_treatment.name_abbreviated }}
          <span
            @click="removeWasteAfterTreatment(wasteOrServiceByDailyReport, index_waste_after_treatment)"
            class="badge badge-light badge-icon-custom"
          >×</span>
        </b-badge>
      </div>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.wastes_after_treatment_by_daily_report`]"
          class="error-message"
        >
          {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.wastes_after_treatment_by_daily_report`][0] }}
        </div>
    </b-row>
    </template>
  </b-card>
</template>

<style scoped lang="scss">
.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}

.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 6px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}

.label-static-width{
  width:200px;
}

.daily-report-input-col-3 {
  width: 29%;
}
.date_of_issue{
  max-width:150px;
  min-width:150px;
}

.manifest_number{
  max-width:150px;
  min-width:150px;
}

.remarks{
  max-width:150px;
  min-width:150px;
}

.car_selected{
  min-width:200px;
  max-width:200px;
}

.user_id{
  max-width:150px;
  min-width:150px;
}

.transport_completed_date{
  max-width:150px;
  min-width:150px;
}

.measurement_quantity{
  max-width:120px;
  min-width:120px;
}

.estimate_cd{
  width:10%;
  min-width:100px;
}
        
.quantity{
  width:15%;
  min-width:100px;
}

.unit{
  width:10%;
  min-width:50px;

}
.unit_price{
  width:10%;
  min-width:70px;
}
.number_of_rental_containers{
  width:20%;
  min-width:100px;
}
.treatment_completed_date{
  max-width:150px;
  min-width:150px;
}
.valuable-involved-type-note{
  font-size: large;
}
.red{
  color:red;
}
.green{
  color:green;
}
.bg_notice{
  background-color: yellow;
}
</style>
